import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToOrder = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('order-bump')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full h-[100svh] flex flex-col bg-gradient-to-b from-[#1a1a2e] to-[#0f0f23] overflow-hidden px-4 pt-2 pb-1.5" data-id="element-74">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-purple-900/15 blur-[80px] rounded-full pointer-events-none" data-id="element-75" />

      {/* Tag - small */}
      <p className="relative z-10 text-center text-[#8B5CF6] text-[10px] font-bold uppercase tracking-widest shrink-0" data-id="element-76">
        Para docentes de matemática sin tiempo para planificar
      </p>

      {/* Title - pyramid: medium → large */}
      <div className="relative z-10 text-center mt-1.5 shrink-0" data-id="element-77">
        <p className="text-[#EAEAEA] text-base font-bold leading-tight tracking-wide uppercase" data-id="element-78">
          1 AÑO DE CLASES DE MATEMÁTICA
        </p>
        <p className="text-[#8B5CF6] text-[34px] font-black leading-none tracking-tight uppercase mt-0.5" data-id="element-79">
          LISTAS PARA USAR
        </p>
      </div>

      {/* Subtitle - medium */}
      <p className="relative z-10 text-white text-[13px] text-center mt-1.5 shrink-0 leading-snug font-medium" data-id="element-80">
        Todo el año de clases resuelto para docentes con poco tiempo
      </p>

      {/* Benefits line - small */}
      <p className="relative z-10 text-[#B0B0B0] text-[10px] text-center mt-1 shrink-0" data-id="element-81">
        Sin improvisar • Sin empezar de cero • Sin perder horas planificando
      </p>

      {/* Mockup - fills available space, no extra margins */}
      <div className="relative z-10 flex-1 flex items-center justify-center min-h-0 -mx-2 my-0 cursor-pointer" onClick={scrollToOrder} data-id="element-82">
        <img src="https://cdn.magicpatterns.com/uploads/s3ThnTku6vD7CG7NNpAMmc/SIN_FONDO.png" alt="Mega Kit Anual de Matemática" className="max-h-full w-full object-contain drop-shadow-2xl scale-110" data-id="element-83" />
      </div>

      {/* Two info blocks */}
      <div className="relative z-10 grid grid-cols-2 gap-2 shrink-0" data-id="element-84">
        <div className="bg-white/[0.07] border border-white/10 rounded-lg p-2.5" data-id="element-85">
          <p className="text-white font-bold text-[11px] mb-1.5 uppercase tracking-wide" data-id="element-86">
            ¿Qué te llevás hoy?
          </p>
          <div className="space-y-1" data-id="element-87">
            {['Clases listas para usar', 'Material imprimible', 'Actividades y ejercicios', 'Organización docente'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-88">
                <CheckCircle2 className="w-3 h-3 text-green-400 shrink-0" data-id="element-89" />
                <span className="text-gray-200 text-[10px] leading-tight" data-id="element-90">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
        <div className="bg-white/[0.07] border border-orange-500/20 rounded-lg p-2.5" data-id="element-91">
          <p className="text-[#F97316] font-bold text-[11px] mb-1.5 uppercase tracking-wide" data-id="element-92">
            🔥 Solo por hoy
          </p>
          <div className="space-y-1" data-id="element-93">
            {['5 bonos de regalo', 'Organización completa del año docente', 'Refuerzo y repaso para todos los alumnos'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-94">
                <CheckCircle2 className="w-3 h-3 text-[#F97316] shrink-0" data-id="element-95" />
                <span className="text-gray-200 text-[10px] leading-tight" data-id="element-96">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Price */}
      <div className="relative z-10 text-center mt-2 shrink-0" data-id="element-97">
        <p className="text-gray-400 text-[11px] uppercase tracking-widest font-semibold" data-id="element-98">
          Precio especial hoy
        </p>
        <p className="text-white mt-0.5" data-id="element-99">
          <span className="text-base font-medium" data-id="element-100">Todo por </span>
          <span className="text-3xl font-black" data-id="element-101">$15.990</span>
          <span className="text-base font-medium" data-id="element-102"> ARS</span>
        </p>
      </div>

      {/* CTA */}
      <button onClick={scrollToOrder} className="relative z-10 w-full bg-green-500 hover:bg-green-400 text-white font-black text-base py-3.5 rounded-xl mt-2 shadow-[0_0_20px_rgba(34,197,94,0.25)] transition active:scale-95 flex items-center justify-center gap-2 uppercase tracking-wide shrink-0" data-id="element-103">
        QUIERO EL MEGA KIT COMPLETO →
      </button>

      {/* Trust */}
      <div className="relative z-10 flex items-center justify-center gap-3 mt-1.5 shrink-0" data-id="element-104">
        {['Descarga inmediata', 'Acceso digital', 'Garantía 7 días'].map((badge, i) => <div key={i} className="flex items-center gap-1" data-id="element-105">
              <CheckCircle2 className="w-3 h-3 text-green-400" data-id="element-106" />
              <span className="text-gray-400 text-[9px]" data-id="element-107">{badge}</span>
            </div>)}
      </div>
    </section>;
}